import { createGlobalStyle } from 'styled-components';

export const RootStyles = createGlobalStyle`
  html, body, #root {
    min-height: 100vh;
  }
`;
